import Breadcrumbs from "./Breadcrumbs.vue";
import FavouriteEmployees from "./FavouriteEmployees/FavouriteEmployees.vue";
import FavouriteTreatments from "./FavouriteTreatments/FavouriteTreatments.vue";
import FavouriteProducts from "./FavouriteProducts/FavouriteProducts.vue";
import UserProfile from "./UserProfile/UserProfile.vue";
import TheConsents from "./Consents/TheConsents.vue";
import OrderHistory from "./OrderHistory/OrderHistory.vue";
import OrderDetails from "./OrderHistory/components/OrderDetails.vue";
import ProductOrderDetails from "./OrderHistory/components/ProductOrderDetails.vue";
import MembershipProgram from "./MembershipProgram/MembershipProgram.vue";
import ProgramInfo from "./MembershipProgram/components/ProgramInfo.vue";
import JoinProgram from "./MembershipProgram/components/JoinProgram.vue";
import PointsHistory from "./MembershipProgram/components/PointsHistory.vue";
import TermsForUse from "./MembershipProgram/components/TermsForUse.vue";
import MySalons from "./MySalons/MySalons.vue";
import PaymentMethods from "./PaymentMethods/PaymentMethods.vue";
import Giftcards from "./Giftcards/Giftcards.vue";
import NoShow from "./NoShow/NoShow.vue";
import NoShowDetails from "./NoShow/components/NoShowDetails.vue";
import Payment from "./NoShow/components/Payment.vue";
import PaymentFooter from "./NoShow/components/PaymentFooter.vue";
import PaymentConfirmation from "./NoShow/components/PaymentConfirmation.vue";
import GiftcardDetails from "./Giftcards/components/GiftcardDetails.vue";
export {
  Breadcrumbs,
  FavouriteEmployees,
  FavouriteTreatments,
  FavouriteProducts,
  UserProfile,
  TheConsents,
  OrderHistory,
  OrderDetails,
  ProductOrderDetails,
  MembershipProgram,
  ProgramInfo,
  PointsHistory,
  TermsForUse,
  MySalons,
  PaymentMethods,
  JoinProgram,
  Giftcards,
  NoShow,
  NoShowDetails,
  Payment,
  PaymentFooter,
  PaymentConfirmation,
  GiftcardDetails,
};
